const Flows = {
  ORDER_AHEAD: "ORDER_AHEAD",
  TAKE_AWAY: "TAKE_AWAY",
  OPEN_TABLE: "OPEN_TABLE",
  DELIVERY: "DELIVERY",
};

const TableServices = {
  ECLETICA: 'ECLETICA',
  SAIPOS: 'SAIPOS',
  NETLOGIC: 'NETLOGIC',
  COLIBRI: 'COLIBRI',
}

export { Flows, TableServices };
